import { Assistant, MessageRole } from "../../../shared/models";
import { useMessageItem } from "./useMessageItem";

interface UseMessageRendererProps {
    messages: any[];
    userName: string;
    readonly: boolean;
    responseInProgress: boolean;
    debug: boolean;
    handleSessionComplete: () => void;
    sendMessage: (message: string) => void;
    assistant?: Assistant;
}

export const useMessageRenderer = ({
    messages,
    userName,
    readonly,
    responseInProgress,
    debug,
    handleSessionComplete,
    sendMessage,
    assistant
}: UseMessageRendererProps) => {

    const { renderMessageItem } = useMessageItem({
        userName,
        readonly,
        responseInProgress,
        debug,
        sendMessage,
        assistant,
        handleSessionComplete
    });

    const renderMessages = () => {
        const messagesToRender = messages.filter(message => {
            if (debug) {
                return true
            }
            return message.role !== MessageRole.System;
        });
        return (
            <section className="pb-[calc(8rem+env(safe-area-inset-bottom))]">
                {messagesToRender.map((message, index) => {
                    return (
                        <span key={index}>
                            {renderMessageItem(message)}
                        </span>
                    )
                })}
            </section>
        )
    };

    return { renderMessages };
};